/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { MidTermModal } from './MidTermModal';



const MidTermLinkWidget: React.FC = () => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <div >
      <a className={` hoverable`} onClick={() => setModalShow(true)}>
        <div className='border bg-light-primary border-primary border-dashed rounded 
                          min-w-125px py-3 px-4 me-6 mb-3 border-hover-success 
                          bg-hover-primary text-hover-white'>
          <div className='d-flex align-items-center'>
            <div className='fs-6 fw-bolder'> Mid Term Addition </div>
          </div>
        </div>
        </a>
      <MidTermModal show={modalShow} handleClose={() => setModalShow(false)} />
    </div>
  )

  
}

export { MidTermLinkWidget }
